// Autogenerated file
export const externalPlatformsEnum = {
    Loginet: "Loginet",
    AtiSu: "AtiSu",
    Atrucks: "Atrucks",
    Pooling: "Pooling",
};
export const externalPlatforms = [
    { label: "Логинет", value: "Loginet" },
    { label: "ATI.SU", value: "AtiSu" },
    { label: "Атракс", value: "Atrucks" },
    { label: "Пулинг", value: "Pooling" },
];
